import "flatpickr/dist/themes/light.css"
import { observer } from 'mobx-react'
import React from "react"
import { MapPin, User, Calendar, AtSign } from "react-feather"
import Flatpickr from "react-flatpickr"
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import "../../../assets/scss/plugins/forms/flatpickr/flatpickr.scss"
import ICustomer from "../../../types/ICustomer";
import InputText from "../../common/InputText";
import InputDate from "../../common/InputDate";

interface ICustomerInfoTabProps {
  customer: ICustomer,
  onChangeText: Function,
  onSave: Function,
  errors: any
}

interface ICustomerInfoTabState {
}

@observer
class CustomerInfoTab extends React.Component<ICustomerInfoTabProps, ICustomerInfoTabState> {

  render() {
    const { customer, onChangeText, onSave, errors } = this.props;
    const { address, personalInfo } = customer;
    
    return (
        <Row className="mt-1">
          <Col className="mt-1" md="4" sm="12">
            <h5 className="mb-1">
              <User className="mr-50" size={16} />
              <span className="align-middle">Personal Info</span>
            </h5>
            <InputDate
              id="dob"
              label="BirthDay"
              placeholder="Enter Birth Date"
              name="dob"
              className="w-100 mr-1 mb-sm-0"
              value={personalInfo.dob}
              error={errors['personalInfo.dob']}
              onChange={(date) => onChangeText("personalInfo.dob", date)}
            />
            <InputText
              type="url" 
              id="website" 
              label="Website"
              className="w-100 mr-1 mb-sm-0"
              name="website"
              value={personalInfo.website}
              error={errors['personalInfo.website']}
              onChange={(e) => onChangeText("personalInfo.website", e.target.value)}
              placeholder="Web Address" 
              controlIcon={<AtSign size={22} />}
            />
          </Col>
          <Col className="mt-1" md="4" sm="12">
            <h5 className="mb-1">
              <MapPin className="mr-50" size={16} />
              <span className="align-middle">Address</span>
            </h5>
            <InputText
              type="text"
              id="address1" 
              name="address1" 
              label="Address1"
              value={address.address1}
              error={errors['address.address1']}
              onChange={(e) => onChangeText("address.address1", e.target.value)}
              placeholder="Address Line 1" 
              controlIcon={<MapPin size={22}/>}
            />
            <InputText
              type="text"
              id="address2" 
              name="address2" 
              label="Address2"
              value={address.address2}
              error={errors['address.address2']}
              onChange={(e) => onChangeText("address.address2", e.target.value)}
              placeholder="Address Line 2" 
            />
            <InputText
              type="text"
              id="pincode" 
              name="pincode" 
              label="PinCode"
              value={address.pincode}
              error={errors['address.pincode']}
              onChange={(e) => onChangeText("address.pincode", e.target.value)}
              placeholder="PinCode" 
            />
            </Col>
            <Col className="mt-1" md="4" sm="12">
            <h5 className="mb-1">
              <MapPin className="mr-50" size={16} />
              <span className="align-middle">Address</span>
            </h5>
            <InputText
              type="text"
              id="city" 
              name="city" 
              label="City"
              value={address.city}
              error={errors['address.city']}
              onChange={(e) => onChangeText("address.city", e.target.value)}
              placeholder="City"
            />
            <InputText
              type="text"
              id="state" 
              name="state" 
              label="State"
              value={address.state}
              error={errors['address.state']}
              onChange={(e) => onChangeText("address.state", e.target.value)}
              placeholder="State"
            />
            <InputText
              type="text"
              id="country" 
              name="country" 
              label="Country"
              value={address.country}
              error={errors['address.country']}
              onChange={(e) => onChangeText("address.country", e.target.value)}
              placeholder="Country" 
            />
          </Col>
        </Row>
    )
  }
}
export default CustomerInfoTab;
